import script from "./otherMOAItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./otherMOAItem.vue?vue&type=script&lang=ts&setup=true"

import "./otherMOAItem.vue?vue&type=style&index=0&id=124dc9af&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-124dc9af"]])

export default __exports__